import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { WorkspaceLifecycle } from 'app/app.types';
import { lifecycleBannerSeverityClass } from 'app/shared/lifecycle/lifecycle-banner-severity.util';
import { isQuillHtmlEmpty } from 'app/shared/quill-editor/quill-html.util';

@Component({
    selector: 'ashcorp-lifecycle-banner',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './lifecycle-banner.component.html',
    styleUrls: ['./lifecycle-banner.component.scss']
})
export class LifecycleBannerComponent {
    @Input() lifecycle: WorkspaceLifecycle | null = null;

    constructor(private _sanitizer: DomSanitizer) {}

    get messageHtml(): SafeHtml {
        const message = `${this.lifecycle?.banner?.message ?? ''}`;
        return this._sanitizer.bypassSecurityTrustHtml(message);
    }

    get visible(): boolean {
        const message = `${this.lifecycle?.banner?.message ?? ''}`;
        return !!this.lifecycle?.banner?.enabled && !isQuillHtmlEmpty(message);
    }

    get severityClass(): string {
        return lifecycleBannerSeverityClass(this.lifecycle?.banner?.severity);
    }
}
